// extracted by mini-css-extract-plugin
export var skipAnimation = "_39-0";